import { httpClient } from "@/api/httpClient";
import qs from "qs";

export function fetchTransactions(filters) {
  return httpClient.get("/transactions", {
    params: {
      asc: "createdAt",
      ...filters,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
}

export function createTransaction(data) {
  return httpClient.post("/transactions", data);
}

export function updateTransaction(id, data) {
  return httpClient.patch(`/transactions/${id}`, data);
}

export function deleteTransaction(id) {
  return httpClient.delete(`/transactions/${id}`);
}
